// Page expandableText
$(document).ready(function() {
	let $controlPlus = $('.expandableText a.controlPlus');
	let $controlMinus = $('.expandableText a.controlMinus');

	if (!$controlPlus.length || !$controlMinus.length) {
		return;
	}

	$controlPlus.click(function () {
		let $this = $(this);

		$('.expandableText').removeClass('expanded');
		$this.parents('.expandableText').addClass('expanded');

		$('html, body').animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.expandableText').offset().top - 10,
		}, 700);

		return false;
	});

	$controlMinus.click(function () {
		let $this = $(this);

		$('.expandableText').removeClass('expanded');

		$('html, body').animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.expandableText').offset().top - 10,
		}, 700);

		return false;
	});
});
